import {twMerge} from 'tailwind-merge';

export default function PrimaryCard({children, ...props}) {
	return (
		<>
			<div className={twMerge([
				"bg-card-bg shadow-small rounded-3xl relative",
				props?.className
			])}>
				{children}
			</div>
		</>
	)
}
